import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, IconButton, Typography } from '@mui/material';
import { AppHeaderPortal, FlexContainer, LoadingPage } from '@act/storybook';
import { UserAdministrationDto } from '@act/shared/data-transfer-objects';
import { useMobile } from '@act/utilities/mobile-context';
import { EditUserActions } from './EditUserActions';

const EditUserHeader = ({
  isEditing,
  handleDeleteUser,
  handleBackButton,
  user,
  hideNavigation,
  handleSave,
  saveDisabled,
}: {
  isEditing: boolean;
  handleDeleteUser?: () => void;
  handleBackButton: () => void;
  user?: UserAdministrationDto;
  hideNavigation?: boolean;
  handleSave?: () => void;
  saveDisabled?: boolean;
}) => {
  const { isMobile } = useMobile();

  const userName = isMobile
    ? `${user?.firstName} ${user?.lastName[0]}.`
    : `${user?.firstName} ${user?.lastName}`;

  const titleText = !!isEditing ? `Edit User: ${userName}` : 'Create User';

  if (!!isEditing && !user) {
    return <LoadingPage />;
  }

  const titleSection = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 3,
      }}
    >
      {!hideNavigation && (
        <IconButton
          color="primary"
          aria-label="back"
          onClick={handleBackButton}
        >
          <ArrowBackIcon />
        </IconButton>
      )}
      <Typography
        variant="headlineMedium"
        color="primary"
        sx={{
          whiteSpace: 'nowrap',
        }}
      >
        {titleText}
      </Typography>
    </Box>
  );

  const editUserActions = (
    <EditUserActions
      isEditing={isEditing}
      handleSave={handleSave}
      handleDeleteUser={handleDeleteUser}
      saveDisabled={saveDisabled}
      isPadded={isMobile}
    />
  );

  return (
    <>
      <AppHeaderPortal>
        <FlexContainer
          direction="row"
          padding={isMobile ? '8px 0' : '12px 24px'}
          height="100%"
          width="100%"
          justifyContent="space-between"
          alignItems="center"
          gap={isMobile ? 0 : 2}
        >
          {titleSection}
          {!isMobile && <Box sx={{ flexShrink: 0 }}>{editUserActions}</Box>}
        </FlexContainer>
      </AppHeaderPortal>
      {isMobile && editUserActions}
    </>
  );
};

export default EditUserHeader;
